import { BehaviorSubject } from 'bog-arcade-core-ui/observer/BehaviorSubject';
import { gameService } from '../apiServices/GameService';
import { BigWinWordAnimation } from '../../core/enums';
import { MULTIPLIER_STATE } from '../../stateManagment';

class BigWinService {
  constructor() {
    this.oddSize = {
      bigWin: 10,
      epicWin: 20,
      superWin: 50,
      megaWin: 100,
      maxWin: 500,
    };
    this.maxWinLimit = 1000;
    this.animation = null;
    this._state = new BehaviorSubject(false);
    this._amount = new BehaviorSubject('100000');
  }

  /**
   * @returns {Boolean}
   */
  get state() {
    return this._state.getValue();
  }

  /**
   * @returns {Number}
   */
  get amount() {
    return this._amount.getValue();
  }

  /**
   * @name setAmount
   * @param value: Number
   */
  setAmount(value) {
    this._amount.next(value);
  }

  subscribe(callback, initialCall = true) {
    return this._state.subscribe(callback, initialCall);
  }

  check(response) {
    let state = false;
    const { odd, winAmount } = response;
    const multiplier = gameService.isBonus ? MULTIPLIER_STATE.getValue() : 1;
    this.setAmount(winAmount);
    const nativeOdd = multiplier * odd;
    if (nativeOdd >= this.oddSize.bigWin) {
      state = true;
      this.animation = BigWinWordAnimation.bigWin;

      if (nativeOdd >= this.oddSize.epicWin) {
        this.animation = BigWinWordAnimation.bigEpicWin;
      }

      if (nativeOdd >= this.oddSize.superWin) {
        this.animation = BigWinWordAnimation.bigSuperWin;
      }

      if (nativeOdd >= this.oddSize.megaWin) {
        this.animation = BigWinWordAnimation.bigMegaWin;
      }

      if (nativeOdd >= this.oddSize.maxWin) {
        this.animation = BigWinWordAnimation.bigMaxWin;
      }
    }

    if (this.checkMaxWin(winAmount)) {
      state = true;
      this.animation = BigWinWordAnimation.bigMaxWin;
    }

    if (state) {
      this.setAmount(winAmount);
    }
    return state;
  }

  checkMaxWin(amount) {
    return amount >= this.maxWinLimit;
  }

  start() {
    if (gameService.isBonus) {
      this._bonusSpinPause();
    } else {
      this._autoSpinPause();
    }
    this._state.next(true);
  }

  end() {
    this._state.next(false);
    if (gameService.isBonus) {
      this._bonusSpinResume();
    } else {
      this._autoSpinResume();
    }
    this.setAmount(0);
  }

  _autoSpinResume = () => {
  };
  _autoSpinPause = () => {
  };
  _bonusSpinResume = () => {
  };
  _bonusSpinPause = () => {
  };

  setAutoSpinResume(callback) {
    this._autoSpinResume = callback;
  }

  setAutoSpinPause(callback) {
    this._autoSpinPause = callback;
  }

  setBonusSpinPause(callback) {
    this._bonusSpinPause = callback;
  }

  setBonusSpinResume(callback) {
    this._bonusSpinResume = callback;
  }
}

export const bigWinService = new BigWinService();
